import React from 'react'
import { Row, Col, Card, Statistic } from 'antd'
import { SyncOutlined, CheckCircleOutlined, MedicineBoxOutlined } from '@ant-design/icons'

const SummaryCards = ({ activeTheatres, idleTheatres, cleaningTheatres, totalProcedures, totalTheatres }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title='Active Theatres'
            value={activeTheatres}
            suffix={`/ ${totalTheatres}`}
            valueStyle={{ color: '#1890ff' }}
            prefix={<SyncOutlined spin />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title='Ready Theatres'
            value={idleTheatres}
            valueStyle={{ color: '#52c41a' }}
            prefix={<CheckCircleOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title='Cleaning'
            value={cleaningTheatres}
            valueStyle={{ color: '#faad14' }}
            prefix={<SyncOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title='Total Procedures Today'
            value={totalProcedures}
            valueStyle={{ color: '#722ed1' }}
            prefix={<MedicineBoxOutlined />}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default SummaryCards
